import { UserType } from 'src/type/user';
import { fDateTime } from 'src/utils/format-time';

type Props = {
  user?: UserType | string;
  updatedAt?: string;
};

export default function UpdatedText({ user, updatedAt }: Props) {
  if (!user || !updatedAt) return null;

  const updatedBy = typeof user === 'string' ? user : user.firstName;

  return `อัพเดทล่าสุดโดย ${updatedBy} เมื่อ ${fDateTime(updatedAt)}`;
}
